import { oc } from 'ts-optchain';

import { StoreType } from '@tock/shared/utils/connect';
import { dashboard } from 'types';
import { safeEnumCompare } from '@tock/coretypes';
import { some } from 'es-toolkit/compat';
import protos from 'utils/protos';

const { ExternalSystemType } = protos;

export function shouldSendPartyStatusUpdates(state: StoreType) {
  return some(
    oc(state.pointOfSale).connectedSystems([]),
    (externalSystem) =>
      safeEnumCompare(externalSystem.system, ExternalSystemType, ExternalSystemType.TOAST) ||
      safeEnumCompare(externalSystem.system, ExternalSystemType, ExternalSystemType.LIGHTSPEED)
  );
}

export const posSystemsWithSkuMapping: dashboard.ExternalSystemType[] = [
  'BLOYAL',
  'COMMERCE7',
  'DYNAMICS_365',
  'TOAST',
  'WINEDIRECT_CLASSIC',
];
